/* unplugin-vue-components disabled */import { render } from "./Download.vue?vue&type=template&id=66662a7a"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__